const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g fill="currentColor" clip-path="url(#a)"><path d="M8 7.967A3.667 3.667 0 1 0 8 .633a3.667 3.667 0 0 0 0 7.334m0 1A6.34 6.34 0 0 0 1.667 15.3c0 .184.149.333.333.333h12a.333.333 0 0 0 .333-.333A6.34 6.34 0 0 0 8 8.967"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
